export default "https://d1e6s5z4lzmgxx.cloudfront.net/9448f7a6-2ffc-48da-926d-72a27a448f00/images/unselected-star-icon.png?bfc161cfdbcd6bd870fcc38a4cf390d9";